import { Component, OnInit } from '@angular/core';
import { Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'itpx-dummy',
    template: '<p>Peep</p>'
})
export class DummyComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private location: Location
    ) { }
 
    ngOnInit() {
        this.route.params
            .take(1)
            // .filter(p => p['back'])
            .subscribe(_ => this.location.back());
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/content/scorm/dummy/dummy.component.ts